import Box from '@mui/material/Box';
import { alpha, keyframes } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`;

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0.4); opacity: 0.3; }
  40% { transform: scale(1); opacity: 1; }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

export const RedirectLoader = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme => (theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.85)' : 'rgba(255,255,255,0.95)'),
        backdropFilter: 'blur(10px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          animation: `${fadeIn} 0.4s ease-out`,
        }}
      >
        <Box
          sx={theme => ({
            width: 72,
            height: 72,
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.12)} 0%, ${alpha(theme.palette.primary.light, 0.06)} 100%)`,
            border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
            animation: `${float} 2.5s ease-in-out infinite`,
          })}
        >
          {/* Shield / lock icon — represents secure authentication */}
          <Box
            component="svg"
            viewBox="0 0 24 24"
            fill="none"
            sx={theme => ({
              width: 32,
              height: 32,
              color: theme.palette.primary.main,
            })}
          >
            <path
              d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z"
              stroke="currentColor"
              strokeWidth={1.8}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 12l2 2 4-4"
              stroke="currentColor"
              strokeWidth={1.8}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </Box>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body1" fontWeight={600} color="text.primary" sx={{ mb: 0.5 }}>
            Preparing secure sign-in
          </Typography>
          <Typography variant="body2" color="text.secondary">
            You are being redirected to the login page
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
          {[0, 1, 2].map(i => (
            <Box
              key={i}
              sx={theme => ({
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: theme.palette.primary.main,
                animation: `${bounce} 1.2s ease-in-out infinite`,
                animationDelay: `${i * 0.15}s`,
              })}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
